import { t } from 'i18next'

import { Render } from '@/components/render-if'
import { NumberInputField } from '@/components/ui'
import { ComboboxField } from '@/components/ui/combobox'
import { CardInfoPercentual } from '@/features/proposta/brasil/components/participacao-compradores/card-info-percentual'
import type { UseParticipacaoCompradoresReturn } from '@/features/proposta/brasil/hooks/use-participacao-compradores'

type ParticipacaoCompradoresGridProps = Readonly<UseParticipacaoCompradoresReturn>

export function ParticipacaoCompradoresGrid({
  titularId,
  titularPercentual,
  cadastroCompradores,
  resumoDistribuicao,
  fields,
  distribuirParticipacoes,
  handleCompradorPercentualBlur,
  control,
  paths,
}: ParticipacaoCompradoresGridProps) {
  return (
    <div className="grid space-y-4">
      <Render.If condition={!!titularPercentual && !!titularId}>
        {() => <CardInfoPercentual resumoDistribuicao={resumoDistribuicao} />}
      </Render.If>
      <div
        className="flex w-full flex-col items-baseline gap-8 border border-neutral-100 p-4 md:flex-row md:flex-wrap"
        data-testid="titular"
      >
        <ComboboxField
          label={t('proposta:detalhes_proposta.participacao_comprador.label.comprador')}
          className="w-full"
          wrapperClassName="w-full md:max-w-50 lg:max-w-96"
          options={cadastroCompradores}
          labelProperty="label"
          valueProperty="id"
          control={control}
          showSearch={false}
          hideClearButton
          name={paths.titularId}
          onSelect={distribuirParticipacoes}
        />
        <div className="w-62">
          <NumberInputField
            numberFieldProps={{ maxValue: 100 }}
            label={t('proposta:detalhes_proposta.participacao_comprador.label.participacao')}
            name={paths.titularPercentual}
            control={control}
            onBlur={distribuirParticipacoes}
          />
        </div>
      </div>
      <Render.If condition={!!(titularPercentual && titularId)}>
        {() =>
          fields.map((field, index) => (
            <div
              key={field.idField}
              className="flex flex-col gap-8 border border-neutral-100 p-4 md:flex-row md:flex-wrap"
              data-testid="comprador"
            >
              <div className="flex w-full flex-col gap-2 py-[6.5px] md:w-50 lg:min-w-96">
                <p className="text-sm font-medium">
                  {t('proposta:detalhes_proposta.participacao_comprador.comprador')}
                </p>
                <p className="text-sm">{cadastroCompradores?.find((p) => p.id === field.id)?.nome}</p>
              </div>
              <div className="w-62">
                <NumberInputField
                  numberFieldProps={{ maxValue: 100 }}
                  label={t('proposta:detalhes_proposta.participacao_comprador.label.participacao')}
                  name={`${paths.compradores}.${index}.percentualParticipacao`}
                  control={control}
                  onBlur={handleCompradorPercentualBlur}
                />
              </div>
            </div>
          ))
        }
      </Render.If>
    </div>
  )
}
